import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isLoading: false,
  data: null,
  error: '',
  isEditingSpeedFormation: false,
  speedFormationDate: null,
  speedFormationSave: {
    isLoading: false,
    error: null,
    errorMessage: null,
  },
  messages: {
    search: '',
    expanded: { welcome: null, scripts: null },
  },
}

const updateHomeIsLoadingHandler = (state, action) => {
  state.isLoading = action.payload
}

const updateHomeDataHandler = (state, action) => {
  state.data = action.payload
}

const updateHomeErrorHandler = (state, action) => {
  state.error = action.payload
}

const setIsEditingSpeedFormationHandler = (state, action) => {
  state.isEditingSpeedFormation = action.payload
}

const setSpeedFormationDateHandler = (state, action) => {
  state.speedFormationDate = action.payload
}

const updateSpeedFormationSaveStatusHandler = (state, action) => {
  state.speedFormationSave = action.payload
}

/** @param {import('@reduxjs/toolkit').PayloadAction<string>} action */
const setHomeMessagesSearchHandler = (state, action) => {
  state.messages.search = action.payload
}

/** @param {import('@reduxjs/toolkit').PayloadAction<{ section: 'welcome' | 'scripts', id: string }>} action */
const toggleHomeMessageHandler = (state, action) => {
  const { section, id } = action.payload
  state.messages.expanded[section] = state.messages.expanded[section] === id ? null : id
}

export const HomeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    updateHomeIsLoading: updateHomeIsLoadingHandler,
    updateHomeData: updateHomeDataHandler,
    updateHomeError: updateHomeErrorHandler,
    setIsEditingSpeedFormation: setIsEditingSpeedFormationHandler,
    setSpeedFormationDate: setSpeedFormationDateHandler,
    updateSpeedFormationSaveStatus: updateSpeedFormationSaveStatusHandler,
    setHomeMessagesSearch: setHomeMessagesSearchHandler,
    toggleHomeMessage: toggleHomeMessageHandler,
    clearHome: () => initialState,
  },
})

export const {
  updateHomeIsLoading,
  updateHomeData,
  updateHomeError,
  setIsEditingSpeedFormation,
  setSpeedFormationDate,
  updateSpeedFormationSaveStatus,
  setHomeMessagesSearch,
  toggleHomeMessage,
  clearHome,
} = HomeSlice.actions

export default HomeSlice.reducer
